import { textareaWrap, HTMLEncode } from '../utils'

/*
* 合格证/水洗唛打印html
* */
export function cardHtml(SelectTypeSize, data, cardName) {
  const nArr = SelectTypeSize.Size.reduce((prev, cur) => {
    if(typeof cur.list =="string"){
      return prev.concat([{typeValue:cur.list}])
    }else{
      return prev.concat(cur.list)
    }

  }, [])
  const sizeList=nArr.filter((value,index,arr)=>{
    return arr.findIndex(x=>x.typeValue===value.typeValue)===index
  })
  let html = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html>
<head>
  <style>
    .pdfpage {
      page-break-after: always;
    }
    .pdfpage:last-child {
      page-break-after: auto;
    }
    * {
      font-family: SimHei;
      color: #000;
      font-size: 12px;
      word-break: break-all;
      word-wrap: break-word;
    }
    .card_content {
      width: 30%;
      margin: auto;
      font-size: 14px;
      border: 1px solid #dcdcdc;
      padding-bottom: 21px;
      background: #fff;
      box-shadow: -4px 5px 0px 0px rgba(0, 0, 0, 0.05);
    }
    .card_tit {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      margin: 0 0 10px;
    }
    .card_icon{
        width: 180px;
        margin-bottom: 8px;
        margin-left: 15px;
      }
    .card_icon img{
        width: 180px;
        height:14px;
        object-fit: cover;
   }
    .card_list_tit {
      display: flex;
      flex-direction: column;
      word-wrap: break-word;
      padding: 2px 0;
      margin: 0 22px;
    }
    .card_label {
      font-size: 12px;
      color: #333;
    }
    .card_value {
      font-size: 12px;
      color: #333;
      word-wrap: break-word;
      word-break: break-all;
    }
    .card_top {
      height: 14px;
      background: #fafafa;
      margin-bottom: 19px;
    }
    .card_value_img img {
      width: 25px;
      height: 25px;
      object-fit: cover;
      margin-right: 8px;
    }
    .card_value_remake{
      display: flex;
      flex-direction: column;
      font-size: 12px;
      margin-top: 10px;
    }
  </style>
</head>
<body>`
  sizeList.forEach(v => {
    html +=  `<div class="card_content pdfpage">
    <div class="card_top"></div>
    `
    if (cardName) {
      html += `<div class="card_tit">${cardName}</div>`
    }
    if (cardName==='水洗唛') {
      html += `<div class="card_icon">
            <img src="https://publicfiles.sgsonline.com.cn/TIC/2022/05/card_top_1652346165111.png" alt="" />
          </div>`
    }
    data.forEach(v1 => {
      // v1.value = HTMLEncode(v1.value)
      if (v1.label === '号型') {
        html += `<div class="card_list_tit">
        <div class="card_label">${v1.label}</div>
        <div class="card_value">${v.typeValue}</div>
      </div>`
      } else if (v1.typeImg) {
        html += `<div class="card_list_tit">
                <div class="card_label">洗涤方法</div>`
        if(v1.showMode !==3){
          html +=`<div class="card_value_img" >`
          v1.value.forEach(v2 => {
            v2.checkIcon.forEach(v3 => {
              html += `<img src="${v3.enumName}" />`
            })
          })
          html += `</div>`
        }
        if(v1.showMode !==2){
          html +=`<div class="card_value_remake" >`
          v1.value.forEach(v2 => {
            v2.checkIcon.forEach(v3 => {
              html += `<div>${v3.remark}</div>`
            })
          })
          html += `</div>`
        }
        html +=`</div>`
      } else if (v1.label==='洗涤提醒') {
        html += `<div class="card_list_tit">
        <div class="card_value">${textareaWrap(v1.value)}</div>
      </div>`
      } else if (v1.required || v1.value) {
        html += `
      <div class="card_list_tit">
        <div class="card_label">${v1.label}</div>
        <div class="card_value">${v1.value}</div>
      </div>
      `
      }
    })
    if (cardName==='水洗唛') {
      html += `<div class="card_icon">
            <img src="https://publicfiles.sgsonline.com.cn/TIC/2022/05/card_bottom_1652346213421.png" alt="" />
          </div>`
    }
    html += `</div>`
  })
  html += `
  </body>
  </html>
  `
  return html
}
